import React, { useState } from 'react';

import { printSvg, printSvgToImage } from '../../helpers/print';

import PrintRenderer from './PrintRenderer';

const Printing = props => {
  const {
    printData,
    printObjIds,
    resultFormat,
    eachItemCallback,
    finishCallback,
  } = props;
  const { fillStyle } = printData;
  const [pageNum, setPageNum] = useState(0);
  const printObjId = printObjIds[pageNum];

  const onRendered = (svgNode) => {
    if (svgNode) {
      (resultFormat === 'svg' ? printSvg : printSvgToImage)(svgNode, { fillStyle }).then(renderedData => {
        if (eachItemCallback) {
          eachItemCallback(renderedData, printObjIds[pageNum], pageNum);
        }

        const nextPrintingPageNum = pageNum + 1;
        if (nextPrintingPageNum < printObjIds.length) {
          // next page print
          setPageNum(nextPrintingPageNum);
        } else {
          if (finishCallback) {
            finishCallback();
          }
        }
      });
    }
  };

  return printObjId ? (
    <PrintRenderer
      key={'print-renderer-' + printObjId}
      {...printData}
      printObjId={printObjId}
      onRendered={onRendered}
    />
  ) : null;
};

export default React.memo(Printing);
